<template>
    
    <div class="w-full h-full flex flex-col items-center justify-start relative">

        <div class="h-20 mt-2 w-full flex flex-row justify-start items-center px-4">

            <div class="h-full w-10  flex flex-col justify-center items-center" @click="exit()">
                <i class="mdi mdi-arrow-left text-2xl text-red z-10"></i>
            </div>

            <div class="flex-1 h-full flex flex-row justify-start items-center px-2">
                <span class="text-white text-lg font-semibold">Condiciones legales</span>
            </div>

        </div>

        <div class="flex-1 w-10/12 shadow-inner bg-font-gray-15 mt-2 overflow-auto mb-4 p-4 text-sm rounded-lg ">

            

        </div>

        <div class="h-20 w-full flex flex-col justify-center items-center">

                <div @click="accept()" class="h-10 w-10/12 rounded-lg bg-filters shadow-md flex flex-row justify-center items-center">
                    <span class="text-white">He Leido y Acepto</span>
                </div>

        </div>

    </div>

</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods:{
        accept(){
            // petición POST para aceptar terminos
        },
        exit(){
            // no acepta terminos, se hace logout y se vuelve al login
        }
    }
}
</script>